/* eslint-disable
    consistent-return,
    new-cap,
    no-func-assign,
    no-return-assign
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';
import React from 'react';
import CreateSequenceAlignmentsModal from 'analyses/alignment/modals/CreateSequenceAlignmentsModal';
import {InputType} from 'analyses/alignment/modals/createSequenceAlignmentsModalReducer';
import * as analytics from 'analytics/Analytics';
import {track} from 'analytics/Analytics';
import SequenceAlignmentTabState from 'molbio/tabstates/SequenceAlignmentTabState';
import * as SequenceAnalysisConstants from 'constants/SequenceAnalysisConstants';
import notifications from 'notifications';
import * as popup from 'Popup';
import AlignmentProgressTemplate from 'toolbar/AlignmentProgressTemplate';
import AlignmentRowTemplate from 'toolbar/AlignmentRowTemplate';
import runModal from 'ui-library/runModal';
import * as DateUtil from 'util/DateUtil';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import ToolbarSignupMessage from 'nav/share/growth/ToolbarSignupMessage';
import {showValueMessagingForSharedFile} from 'nav/share/growth/Util';
import {maybeShowBadAlignmentError} from 'analyses/alignment/AlignmentActions';
import {renderSinglePanelTab} from './shared/PanelUtil';

export function _canDeleteAlignments(sequence) {
  return sequence.get('permissions').polymerFeaturesEditable;
}

export class AlignmentItemView extends Backbone.View {
  static initClass() {
    this.prototype.template = AlignmentRowTemplate;
    this.prototype.tagName = 'tr';
    this.prototype.className = 'panel-library-row';
    this.prototype.events = {
      click: 'openAlignment',
      'click .delete': 'deleteAlignment',
    };
  }

  initialize(options) {
    return ({checkDelete: this.checkDelete} = options);
  }

  openAlignment(e) {
    // Don't go through if triggered from delete icon.
    if ($(e.target).hasClass('delete')) {
      return;
    }
    return this.model.trigger('openAlignment', this.model);
  }

  deleteAlignment() {
    // Duplicated in restriction panel.
    const tab = this.checkDelete(this.model);
    const alignmentName = _.escape(this.model.get('name'));

    function destroyCallback() {
      analytics.track('alignment', 'delete_alignment');
      return this.model
        .destroy()
        .fail(() => notifications.error('An error occurred while trying to delete the alignment.'))
        .done(() => {
          notifications.success(
            <>
              Sequence alignment <strong>{alignmentName}</strong> successfully deleted.
            </>
          );
          this.remove();
          if (tab != null) {
            return tab.close();
          }
        });
    }

    // eslint-disable-next-line no-restricted-syntax
    destroyCallback = _.bind(destroyCallback, this);
    const confirmMessage =
      tab == null
        ? `Are you sure you want to delete <b>${alignmentName}</b>?`
        : `<b>${alignmentName}</b> is currently open in a tab - are you sure you want to delete it and close its tab?`;

    return new popup.Confirm({title: 'Confirm Deleting Alignment', msg: confirmMessage})
      .choice('Delete', 'btn-af-danger', destroyCallback)
      .choice('Cancel', 'btn-af-default')
      .show();
  }

  render() {
    const d = new Date(this.model.get('created_at'));
    this.$el.html(
      this.template({
        name: this.model.get('name'),
        time: DateUtil.readableTime(d),
      })
    );
    return this;
  }
}
AlignmentItemView.initClass();

class AlignmentPanelView extends Backbone.View {
  static initClass() {
    this.prototype.el = '#alignment-panel';
    this.prototype.events = {
      'click .new-alignment-btn': 'openModal',
      'click .js-alignment-sort': 'sortAlignments',
    };
  }

  initialize() {
    return (this.sort = this.sortByName);
  }

  openModal() {
    if (window.user == null) {
      window.location = '/signup';
      return;
    }
    track('alignment', 'openModal', {source: 'alignment-panel'});

    runModal(CreateSequenceAlignmentsModal, {
      initialInputs: [
        {
          type: InputType.BIOENTITY,
          name: this.sequence.name(),
          id: this.sequence.get('id'),
          canBeTemplate: this.sequence.permissions().polymerFeaturesEditable,
          useCurrentVersion: true,
          nucleotideType: this.sequence.nucleotideType(),
        },
      ],
    });
  }

  update(state, sequence) {
    if (this.panelState != null) {
      this.stopListening(this.panelState);
      this.stopListening(this.panelState.get('alignmentsInProgress'));
    }
    if (this.sequence != null) {
      this.stopListening(this.sequence.get('_sequence'));
      this.stopListening(this.sequence.get('analyses'));
    }
    this.panelState = state;
    this.listenTo(this.panelState.get('alignmentsInProgress'), 'add remove change', this.renderInProgress);
    if (this.sequence != null) {
      this.stopListening(this.sequence.get('analyses'));
    }
    this.sequence = sequence;
    this.buffers = state.get('buffers');
    this.listenTo(this.sequence, 'change:writable change:permissions change:currentVersion', this.render);
    this.listenTo(this.sequence.get('_sequence'), 'change:finalized', this.render);
    this.listenTo(this.sequence.get('analyses'), 'add remove change reset', this.render);
    this.listenTo(this.sequence.get('analyses'), 'openAlignment', this.openAlignment);
    this.listenTo(this.sequence.get('analyses'), 'newAlignment', this.newAlignment);
    return this.render();
  }

  sortByName(one, two) {
    const rv = one.get('name').localeCompare(two.get('name'));
    if (rv !== 0) {
      return rv;
    }
    return two.get('id') - one.get('id');
  }

  sortByDate(one, two) {
    return two.get('id') - one.get('id');
  }

  sortAlignments(e) {
    const $el = this.$(e.currentTarget);
    $el.addClass('hidden');
    if ($el.hasClass('js-sort-name')) {
      this.$('.js-sort-time').removeClass('hidden');
      this.sort = this.sortByDate;
    } else {
      this.$('.js-sort-name').removeClass('hidden');
      this.sort = this.sortByName;
    }
    this.renderLibrary();
  }

  openAlignment(alignment) {
    analytics.track('alignment', 'open_saved_alignment');
    let tab = this.sequence.fileState().findAlignmentTab(alignment);
    if (tab != null) {
      this.$el.find('.library-opening-spinner').removeClass('hidden');
      // In case activating the tab (ie rendering the alignment) is slow,
      // ensure that the spinner is shown by waiting an animation frame
      // before starting the intensive rendering.
      setTimeout(() => {
        this.sequence.fileState().setIsWorkspaceSplit(false);
        tab.set('active', true);
        this.$el.find('.library-opening-spinner').addClass('hidden');
        this.panelState.trigger('close');
      }, 10);
    } else {
      this.$el.find('.library-opening-spinner').removeClass('hidden');
      tab = new SequenceAlignmentTabState({
        sequence: this.sequence,
        analysisId: alignment.id,
        alignmentId: alignment.get('apiId'),
      });
      this.sequence.fileState().setIsWorkspaceSplit(false);
      this.buffers.addTab(tab);
      alignment
        .fetch({parse: true})
        .done((parsedAlignment) => {
          maybeShowBadAlignmentError(parsedAlignment, tab);
          if (parsedAlignment?.alignments == null) {
            this.$el.find('.library-opening-spinner').addClass('hidden');
            return;
          }
          tab.loadAnalysis(alignment);
          this.$el.find('.library-opening-spinner').addClass('hidden');
          this.panelState.trigger('close');
        })
        .fail((res) => {
          notifications.notifyError(res);
          this.$el.find('.library-opening-spinner').addClass('hidden');
          tab.close();
        });
    }
  }

  renderInProgress() {
    const alignmentsInProgress = this.panelState.get('alignmentsInProgress');
    const els = alignmentsInProgress.map((progress) =>
      AlignmentProgressTemplate({
        algorithm: progress.get('algorithm'),
        numSequences: progress.get('numSequences'),
        created: DateUtil.readableTime(progress.get('created')),
      })
    );
    this.$('.in-progress').toggleClass('hidden', els.length === 0);
    return this.$('.in-progress-library tbody').html(els);
  }

  renderLibrary() {
    const table = this.$el.find('table.alignment-library');
    const alignAnalyses = this.sequence
      .get('analyses')
      .filter((analysis) => analysis.get('analysis_type') === SequenceAnalysisConstants.ALIGNMENT);
    alignAnalyses.sort(this.sort);

    const checkDelete = (alignment) => this.sequence.fileState().findAlignmentTab(alignment);
    const els = Array.from(alignAnalyses).map(
      (alignAnalysis) => new AlignmentItemView({model: alignAnalysis, checkDelete}).render().el
    );
    if (els.length > 0) {
      table.find('tbody').html(els);
    } else {
      table.find('tbody').html($('<tr>').append('<td>').text('No sequence alignments'));
    }

    return this.$el
      .find('.panel-library-row .delete')
      .toggleClass('hidden', !_canDeleteAlignments(this.sequence));
  }

  render() {
    renderSinglePanelTab('Sequence Alignments', this.$('.panel-title')[0]);
    const $alignmentBtn = this.$el.find('.new-alignment-btn');
    // Cache the original text.
    if ($alignmentBtn.data('text') == null) {
      $alignmentBtn.data('text', $alignmentBtn.text());
    }
    $alignmentBtn.toggleClass(
      'disabled',
      !this.sequence.allowFeatureEdits({ignoreLocked: true}) ||
        this.sequence.isReallyBig() ||
        !this.sequence.finalized()
    );
    if (showValueMessagingForSharedFile()) {
      $alignmentBtn.addClass('hide');
      renderToDOM(
        <ToolbarSignupMessage action="create an alignment" />,
        this.$el.find('.share-link-message-react-mount')[0]
      );
    } else if (window.user == null) {
      $alignmentBtn.text('Sign up to create alignment').removeClass('disabled', false);
    } else if (!this.sequence.allowFeatureEdits({ignoreLocked: true})) {
      $alignmentBtn.text('Create alignment disabled when read-only');
    } else {
      $alignmentBtn.text($alignmentBtn.data('text'));
      if (this.sequence.isReallyBig()) {
        this.$('.new-alignment-btn').parent().tooltip({
          placement: 'bottom',
          container: 'body',
          title: 'Alignments are not currently supported for large sequences.',
        });
      } else if (!this.sequence.finalized()) {
        this.$('.new-alignment-btn').parent().tooltip({
          placement: 'bottom',
          container: 'body',
          title: 'Finalize the sequence from the Assembly tab to enable alignments.',
        });
      } else {
        this.$('.new-alignment-btn').parent().tooltip('destroy');
      }
    }
    this.$('.js-alignment-sort').tooltip({
      container: 'body',
    });
    this.renderLibrary();
    this.renderInProgress();
    return this;
  }
}
AlignmentPanelView.initClass();

export default AlignmentPanelView;
